import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import { Button, Form, FormGroup, FormText, Input, Label, Table } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';

class HonorsKeycardAccess extends Component {
    static displayName = HonorsKeycardAccess.name;

    constructor(props) {
        super(props);
        this.state = { //Given the length of this component's state variables you might think at least one of these is an unused leftover from when this component was copy/pasted 
                       //from DormTrans.js to build it.You'd be surprised to learn I'm 90% sure all of these are actually used.
            returnable: this.props.reduxData.userInfo,
            enterPCID: this.props.reduxData.userInfo.username,
            studentName: "",
            ip: "",
            globalLevel: this.props.reduxData.userInfo.level.pk,
            browser: `${browserName}${browserVersion}`,
            submittedFlag: false,
            permissionFlag: true,
            tableData: [],
            newDate: "",
            termOptions: [],
            deleteFlag: false,
        };
        this.getTableData();
        this.testPermission()
        this.getTermData();//At least one of these can probably be put inside another to properly serialize them, but given how these are all independent of each other in terms of 
                           //their function there's no need to
    }

    componentDidMount() {
        
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getImportantThings();
    }

    async getImportantThings() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            enterPCID: this.props.reduxData.userInfo.username,
            globalLevel: this.props.reduxData.userInfo.level.pk,
            returnable: this.props.reduxData.userInfo
        })
        var dept = this.props.reduxData.userInfo.level.pk
        dept = dept.substring(0, (dept.indexOf('-') - 1));
        //this.recordComingHere();
        this.getTableData();
        this.testPermission();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1022", //Most other pages will have PKs in the low double digits, but since PKs are auto-generated and there's one with a value of 1021 new pages like this one will have PKs like this. 
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
        
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1022"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async nameLookup(e) { //This nameLookup() is exactly the same as the one in DormTrans.js
        if (e.target.value.length == 10) {
            //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let bearerVAR = "Bearer " + this.props.reduxData.apiKey
            this.props.updateFetchTime();
            let toSend = {
                stuPCID: e.target.value,
                userLevel: this.props.reduxData.userInfo.level.pk
            }
            const response = await fetch('stuLookupHonors', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            this.setState({
                studentName: data.stuName
            });
        } else {
            this.setState({
                studentName: ""
            })
        }
    }

    async addNew(e) { //While this addNew() is mostly the same as the one in DormTrans.js, the primary difference is that the building and room values are hard-coded. 
                      //That's because this form is only going to grant access to one room, so there's no need to ask the user which room to grant access to since we 
                      //know everyone being granted access here is going to just that room
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        let toSend = {
            studentPCID: dataInput.get('stuPCID'),
            building: "New Hall/Blazer Hall (NH)",
            room: "106A",
            expDate: dataInput.get('term'),
            recorderName: this.state.enterPCID,
            flag: "HONORS",
            activeLevel: this.state.globalLevel
        };
        const response = await fetch('addtransition', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            submittedFlag: data
        });
        setTimeout(() => {
            this.setState({
                submittedFlag: false
            })
        }, 4000)
        this.getTableData();
    }

    async getTermData() { //We only want to display the terms that are active or will be active, so all terms that have an end date after the current date
        //We also want to display terms with the year associated with them, just in case
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        console.log("begin get term data")
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        console.log("bearerVAR ",bearerVAR)
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        console.log("toSend", toSend)
        console.log("stringify(toSend) " + JSON.stringify(toSend))
        const response = await fetch('HonorsTerms', {
            method: 'POST',
            headers: { 'Authorization': bearerVAR,'Content-Type': 'application/json' },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            termOptions: data
        })
    }

    async getTableData() { //This functions very similarly to TransControler.cs, but only finds the honors permission records instead of the dorm ones.
                           //While it will display information regarding the building and room even though every record this fetch finds will have the same values for these, this
                           //hasn't been considered an urgent fix. However, because the fact we're using a different controller for this gives us options in this regard, pruning
                           //the table's fields is something to seriously consider (especially since the last field is admittedly a bit crowded right now)
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('HonorsData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data
        });
    }

    async deleteField(pcid, pk) { //While it appears to the user that the permission is deleted, the functionality behind it here is near identical to UpdateTransController.cs and could
                              //possibly be merged in the future. However, leaving them two separate controllers is wiser until we know we can combine them as it allows options should
                              //we need them in the future
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            recordPK: pk, //Including the record PK makes the PCID relatively superfluous, but we will pass it anyway in the interest of being thorough
            pcid: pcid,
            activeLevel: this.state.globalLevel
        }
        const response = await fetch('deleteHonors', {
            method: 'POST', //All this is doing is doing the update expiration date function and setting the expiration date to yesterday
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            submittedFlag: data
        })
        setTimeout(() => {//We will give the user ten seconds to consider the change they've made before refreshing the table. They won't be able to stop it, but they can re-enter
                          //the deleted record afterward
            this.setState({
                submittedFlag: false
            })
            this.getTableData(); //The refresh of the table is in the timeout here because we want to make sure the old record is still visible for those ten seconds in case the user 
                                 //realizes they don't actually want to do this.
        }, 1000)
        
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        } //This reads the active permission state flag and if it's false then the user doesn't have permission to be here, so we send them off to AccessForbidden.js
        return (
            <UserContext.Consumer>
                {contextData => (
                    <div>
                        <Form className='d-flex' onSubmit={this.addNew.bind(this)}>
                            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <Label className="mr-sm-2">PCID</Label>
                                <Input onChange={this.nameLookup.bind(this)} type="text" name="stuPCID" id="stuPCID" bsSize="sm" />
                                <FormText>{this.state.studentName}</FormText>
                            </FormGroup>
                            <br />
                            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                <Label className="mr-sm-2">Term:</Label>
                                <Input type="select" name="term" id="term" bsSize="sm">
                                    {this.state.termOptions.map(size => (
                                        <option>{size}</option>
                                        ))}
                                </Input>
                            </FormGroup>
                            <br />
                            <Button type="submit">Submit</Button>&emsp;<div style={{ visibility: this.state.submittedFlag == true ? 'visible' : 'hidden' }}> Success! <GoCheck style={{ visibility: this.state.submittedFlag == true ? 'visible' : 'hidden' }} /></div>
                        </Form>
                        <Table striped>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>PCID</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Nickname</th>
                                    {/*<th>Building</th>
                                    <th>Room</th>*/}
                                    <th>Expiration Date</th>
                                    <th>Entered On</th>
                                    <th>Entered By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.tableData.map(size => (
                                    <tr>
                                        <th>{size.pk}</th>
                                        <td>{size.pcid}</td>
                                        <td>{size.firsT_NAME}</td> 
                                        <td>{size.lasT_NAME}</td> {/*No, I don't know why the capitalization is all weird here. I didn't write it like this but JSON has other plans for us.*/}
                                        <td>{size.nickname}</td>
                                        {/*<td>{size.building}</td>
                                        <td>{size.room}</td>*/}
                                        <td>{size.expiration_Date}</td>
                                        <td>{size.enteredOn}</td>
                                        <td>{size.enteredBy}  <Button outline color="danger" size="sm" onClick={() => { this.deleteField(size.pcid, size.pk) }}>Delete</Button> <div style={{ visibility: this.state.deleteFlag == true ? 'visible' : 'hidden' }}> Success! <GoCheck style={{ visibility: this.state.deleteFlag == true ? 'visible' : 'hidden' }} /></div></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </UserContext.Consumer>
        );
    }    
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(HonorsKeycardAccess);